import pastasGerencias from '~/graphql/pre-defined-filters/pastasGerencias';
import pastasResponsaveis from '~/graphql/pre-defined-filters/pastasResponsaveis';

interface PastasGcpjDesatualizadoOptions {
  gerencia?: number;
  responsaveis?: string[];
}

export default function (options?: PastasGcpjDesatualizadoOptions) {
  const ands: any[] = [];

  if (options?.gerencia) {
    ands.push(pastasGerencias(options.gerencia));
  }

  if (options?.responsaveis && options?.responsaveis.length > 0) {
    ands.push(pastasResponsaveis(options.responsaveis));
  }

  return {
    gcpjDesatualizado: true,
    where: {
      and: ands,
    },
  };
}
